import React, {Fragment, useEffect} from "react";

// reactstrap components
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
// layout for this page
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import CounselingService from "../../../services/counseling.service";
import PaginationWrapper from "../components/pagination";
import {numberWithCommas, paginate} from "../../../utils";
import useHistoryState from "../../../common/useHistoryState";
import classnames from "classnames";
import ReactDatetime from "react-datetime";
import moment from "moment";
import {Link} from "react-router-dom";
import companyService from "./service/company.service";
import {useHistory} from "react-router";
import {shopCategory} from "../shop/service/shop.category";
import storeService from "../store/service/store.service";

function CompanyList() {
  const history = useHistory();
  const [pageActive, setPageActive] = useHistoryState(1, 'pageActive');
  const [pageCount, setPageCount] = useHistoryState(1, 'pageCount');
  const [data, setData] = useHistoryState([], 'data');
  const [category, setCategory] = useHistoryState('전체', 'category');
  const [startDate, setStartDate] = useHistoryState(moment().format('YYYY-MM-01'), 'startDate');
  const [endDate, setEndDate] = useHistoryState(moment().format('YYYY-MM-DD'), 'endDate');
  const [searchCurrent, setSearchCurrent] = useHistoryState(false, 'searchCurrent');
  const [search, setSearch] = useHistoryState('', 'search');

  const render = async () => {
    const res = await companyService.list({ page: pageActive });
    if (res.code === 200) {
      console.log(res);
      setPageCount(res.list.count);
      setData(res.list.rows);
    }
  };

  useEffect(() => {
    render();
  }, [ pageActive ]);

  const statusChange = async (id, check) => {
    await companyService.update(id, check);
    render();
  }

  const remove = async (id) => {
    if (window.confirm('삭제하시겠습니까?')) {
      let res = await companyService.remove(Number(id));
      console.log(res);
      if (res.code === 200) {
        render();
      }
    }
  };

  return (
    <>
      <SimpleHeader name="Tables" parentName="Tables" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader className="border-0">
                <Row>
                  <Col xs="6">
                    <h3 className="mt-2">
                      기업 관리
                    </h3>
                  </Col>
                  <Col className="text-right" xs="6">
                    <Button
                        className="btn-round btn-icon"
                        color="default"
                        onClick={(e) => history.push('/admin/companyForm')}
                    >
                      <span className="btn-inner--text">등록하기</span>
                    </Button>
                  </Col>
                </Row>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive striped>
                <thead className="thead-light">
                <tr>
                  <th className="text-center">등록일</th>
                  <th className="text-center">상점 구분 명</th>
                  <th className="text-center">기업명</th>
                  <th className="text-center">기업코드명</th>
                  <th className="text-center">나눔탭(기부랭킹) 배너</th>
                  <th className="text-center">포아브탭 배너</th>
                  <th className="text-center">기존버전 / 기부화면</th>
                  <th className="text-center">메인버전</th>
                  <th className="text-center">자동 걸음 수집</th>
                  <th className="text-center">광고여부</th>
                  <th className="text-center">임직원랭킹여부</th>
                  <th className="text-center">지점 리스트</th>
                  <th className="text-center">관리</th>
                </tr>
                </thead>
                <tbody>
                {data?.map((item, i) => {
                  return [
                    <Fragment key={i}>
                      <tr>
                        <td className="text-center">
                          {item.createdAt}
                        </td>
                        <td className="text-center">
                          {item.diff}
                        </td>
                        <td className="text-center">
                          {item.name}
                        </td>
                        <td className="text-center">
                          {item.code}
                        </td>
                        <td className="text-center">
                          <label className="custom-toggle custom-toggle-success center">
                            <input
                                checked={item.isShareBanner}
                                type="checkbox"
                                onChange={(e) => statusChange(item.id, {isShareBanner: !item.isShareBanner})}
                            />
                            <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="No"
                                data-label-on="Yes"
                            />
                          </label>
                        </td>
                        <td className="text-center">
                          <label className="custom-toggle custom-toggle-success center">
                            <input
                                checked={item.idFoavBanner}
                                type="checkbox"
                                onChange={(e) => statusChange(item.id, {idFoavBanner: !item.idFoavBanner})}
                            />
                            <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="No"
                                data-label-on="Yes"
                            />
                          </label>
                        </td>
                        <td className="text-center">
                          <label className="custom-toggle custom-toggle-success center">
                            <input
                                checked={item.charityVersion}
                                type="checkbox"
                                onChange={(e) => statusChange(item.id, {charityVersion: !item.charityVersion})}
                            />
                            <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="No"
                                data-label-on="Yes"
                            />
                          </label>
                        </td>
                        <td className="text-center">
                          <label className="custom-toggle custom-toggle-success center">
                            <input
                                checked={item.mainVersion}
                                type="checkbox"
                                onChange={(e) => statusChange(item.id, {mainVersion: !item.mainVersion})}
                            />
                            <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="No"
                                data-label-on="Yes"
                            />
                          </label>
                        </td>
                        <td className="text-center">
                          <label className="custom-toggle custom-toggle-success center">
                            <input
                                checked={!!item.autoStepCollection}
                                type="checkbox"
                                onChange={() => statusChange(item.id, {autoStepCollection: !item.autoStepCollection})}
                            />
                            <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="Off"
                                data-label-on="On"
                            />
                          </label>
                        </td>
                        <td className="text-center">
                          <label className="custom-toggle custom-toggle-success center">
                            <input
                                checked={item.isAdd}
                                type="checkbox"
                                onChange={(e) => statusChange(item.id, {isAdd: !item.isAdd})}
                            />
                            <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="No"
                                data-label-on="Yes"
                            />
                          </label>
                        </td>
                        <td className="text-center">
                          <label className="custom-toggle custom-toggle-success center">
                            <input
                                checked={item.isRank}
                                type="checkbox"
                                onChange={(e) => statusChange(item.id, {isRank: !item.isRank})}
                            />
                            <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="No"
                                data-label-on="Yes"
                            />
                          </label>
                        </td>
                        <td className="text-center">
                          <Button
                              className="btn-outline-default"
                              onClick={() => history.push('/admin/companySubList/' + item.id + '/' + item.name)}
                              size="sm"
                          >
                            <span className="btn-inner--text">상세</span>
                          </Button>
                        </td>
                        <td className="text-center">
                          <Button
                              className="btn-outline-danger"
                              onClick={() => remove(item.id)}
                              size="sm"
                          >
                            <span className="btn-inner--text">삭제</span>
                          </Button>
                          <Button
                              className="btn-outline-default"
                              onClick={() => history.push('/admin/companyDetail/' + item.id)}
                              size="sm"
                          >
                            <span className="btn-inner--text">상세</span>
                          </Button>
                        </td>
                      </tr>
                    </Fragment>
                  ];
                })}
                </tbody>
              </Table>

              <CardFooter className="py-4">
                <PaginationWrapper
                  isActive={pageActive}
                  pageNumber={pageCount}
                  callback={(page) => setPageActive(page)}
                  itemPerPage={10}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default CompanyList;
